<template>
  <v-layout>
    <v-col class="custom-content-container pt-0" cols="12" md="12" sm="12">
      <template>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll"
          style="max-height: calc(100vh - 200px); position: relative"
        >
          <v-layout class="d-block iv-custom-field">
            <v-container fluid class="pt- px-1">
              <v-row>
                <v-col class="pt-0" cols="12">
                  <v-card
                    flat
                    class="custom-grey-border remove-border-radius mb-4"
                  >
                    <v-card-title
                      class="headline py-2 d-flex align-center justify-space-between"
                    >
                      <span
                        class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                      >
                        Contact Persons
                      </span>
                      <v-btn
                        class="custom-bold-button white--text rounded-lg px-4 text-capitalize"
                        v-on:click="addContactPerson()"
                        color="cyan darken-1"
                        small
                        depressed
                      >
                        <v-icon left small>mdi-account-plus</v-icon>
                        Add Contact Person
                      </v-btn>
                    </v-card-title>

                    <v-card-text class="pa-0">
                      <v-simple-table width="100%" class="modern-erp-table">
                        <thead>
                          <tr>
                            <th
                              class="simple-table-th text-center"
                              style="width: 50px"
                            >
                              #
                            </th>
                            <th class="simple-table-th">Contact Name</th>
                            <th class="simple-table-th">Email Address</th>
                            <th class="simple-table-th">Designation</th>
                            <th class="simple-table-th">Mobile Number</th>
                            <th class="simple-table-th">DID</th>
                            <th class="simple-table-th">Landline Number</th>
                            <th
                              class="simple-table-th text-center"
                              style="width: 100px"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="localContactPersons.length > 0">
                          <tr
                            v-for="(row, index) in localContactPersons"
                            :key="row.uuid || index"
                            class="table-row-hover"
                          >
                            <td
                              class="cursor-default simple-table-td text-center font-weight-medium grey--text text--darken-2"
                            >
                              {{ index + 1 }}
                            </td>

                            <td
                              class="cursor-default simple-table-td font-weight-bold grey--text text--darken-3"
                            >
                              <template v-if="row && row.name">
                                <div class="d-flex align-start">
                                  <v-icon
                                    small
                                    color="cyan darken-1"
                                    class="mr-2 mt-1"
                                    >mdi-account-outline</v-icon
                                  >
                                  <div class="d-flex flex-column align-start">
                                    <span>{{ row.name }}</span>
                                    <v-chip
                                      x-small
                                      color="blue darken-1"
                                      label
                                      class="white--text font-weight-bold mt-1 text-uppercase"
                                      v-if="row.primary == 1"
                                    >
                                      Primary
                                    </v-chip>
                                  </div>
                                </div>
                              </template>
                              <em v-else class="grey--text text--lighten-1"
                                >No Name</em
                              >
                            </td>

                            <td class="cursor-default simple-table-td">
                              <template v-if="row && row.email">
                                <span
                                  class="cyan--text text--darken-2 font-weight-medium"
                                  style="overflow-wrap: anywhere; word-break: break-word"
                                  >{{ row.email }}</span
                                >
                              </template>
                              <em v-else class="grey--text text--lighten-1"
                                >No Email</em
                              >
                            </td>

                            <td class="cursor-default simple-table-td">
                              <template v-if="row && row.designation">
                                <span>{{ row.designation }}</span>
                              </template>
                              <em v-else class="grey--text text--lighten-1"
                                >No Position</em
                              >
                            </td>

                            <td class="cursor-default simple-table-td">
                              <template v-if="row && row.phone">
                                <span>{{ row.phone }}</span>
                              </template>
                              <em v-else class="grey--text text--lighten-1"
                                >No Phone</em
                              >
                            </td>

                            <td class="cursor-default simple-table-td">
                              <template v-if="row && row.did">
                                <span>{{ row.did }}</span>
                              </template>
                              <em v-else class="grey--text text--lighten-1"
                                >No DID</em
                              >
                            </td>

                            <td class="cursor-default simple-table-td">
                              <template v-if="row && row.landline">
                                <span>{{ row.landline }}</span>
                              </template>
                              <em v-else class="grey--text text--lighten-1"
                                >No Landline</em
                              >
                            </td>

                            <td class="simple-table-td text-center">
                              <div class="d-flex align-center justify-center">
                                <v-btn
                                  class="mr-1 rounded-lg"
                                  color="cyan darken-1"
                                  depressed
                                  outlined
                                  min-width="34px"
                                  width="34px"
                                  v-bind="attrs"
                                  v-on:click="updateContactPerson(row)"
                                  
                                >
                                  <v-icon x-small>mdi-pencil</v-icon>
                                </v-btn>

                                <template v-if="index > 0">
                                  <v-menu
                                    top
                                    content-class="delete-small-confirm"
                                    v-model="row.menu"
                                    :close-on-content-click="false"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        class="rounded-lg"
                                        color="red lighten-1"
                                        depressed
                                        outlined
                                        x-small
                                        fab
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon small dark
                                          >mdi-trash-can-outline</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <DeleteSmallConfirm
                                      :message="`Are you sure, you want to delete <span class='red--text'>${row.name}</span> ?`"
                                      v-on:cancel="row['menu'] = false"
                                      v-on:success="removeContactPerson(index)"
                                    >
                                    </DeleteSmallConfirm>
                                  </v-menu>
                                </template>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tfoot v-else>
                          <tr>
                            <td colspan="8">
                              <div class="my-8 row-not-found text-center">
                                <img
                                  :src="$assetURL('media/error/empty.png')"
                                  class="row-not-found-image mb-3"
                                  style="max-width: 80px"
                                />
                                <div
                                  class="font-weight-bold grey--text text--darken-3 font-size-16"
                                >
                                  No contact persons found.
                                </div>
                                <div class="text-caption grey--text mt-1">
                                  Click "Add Contact Person" above to create
                                  one.
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tfoot>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-layout>
        </perfect-scrollbar>

        <template v-if="dialog">
          <CreateContactPerson
            :person-alldata="editAllData"
            :value="localContactPersons"
            v-on:input="updateContactPersons"
            :person-dialog="dialog"
            :person-uuid="editPersonUUID"
            v-on:close="
              editPersonUUID = null;
              dialog = false;
            "
            :do-update="updateSelf"
          ></CreateContactPerson>
        </template>
      </template>
    </v-col>
  </v-layout>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import DeleteSmallConfirm from "@/view/pages/partials/DeleteSmallConfirm";
import CreateContactPerson from "@/view/pages/lead-new/create-or-update/Create-Contact-Person";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "contact-persons",
  title: "Lead",
  mixins: [CommonMixin, ValidationMixin, CustomerMixin],
  props: {
    contactPersons: {
      type: Array,
      default: function () {
        return [];
      },
    },
    detail: {
      type: Object,
      default: function () {
        return {};
      },
    },
    lead: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editAllData: {},
      localContactPersons: [],

      dialog: false,
      updateSelf: false,
      editPersonUUID: null,
      contactPerson: {
        id: null,
        uuid: uuidv4(),
        name: null,
        email: [],
        designation: null,
        phone: null,
        did: null,
        landline: null,
        primary: 0,
        will_notified: 1,
      },
    };
  },
  watch: {
    contactPersons: {
      deep: true,
      immediate: true,
      handler(param) {
        this.localContactPersons = this.lodash.cloneDeep(param);
      },
    },
  },
  methods: {
    openDeleteMenu(row) {
      this.$set(row, "menu", true);
    },
    closeDeleteMenu(row) {
      this.$set(row, "menu", false);
    },
    emitContactPersons() {
      this.$emit(
        "saveContactPerson",
        this.lodash.cloneDeep(this.localContactPersons)
      );
    },
    updateContactPersons(persons) {
      this.localContactPersons = this.lodash.cloneDeep(persons);
      this.emitContactPersons();
    },
    updateContactPerson(param) {
      this.editPersonUUID = param.uuid;
      this.editAllData = param;
      this.contactPerson = param;
      this.updateSelf = true;
      this.dialog = true;
    },

    addContactPerson() {
      this.editPersonUUID = null;
      this.updateSelf = false;
      this.dialog = true;
    },

    pushContactPerson() {
      this.localContactPersons.push({
        id: null,
        uuid: uuidv4(),
        name: null,
        email: null,
        designation: null,
        phone: null,
        did: null,
        landline: null,
        primary: 0,
        will_notified: 1,
      });
      this.emitContactPersons();
    },
    removeContactPerson(index) {
      this.localContactPersons.splice(index, 1);
      this.emitContactPersons();
    },
  },
  components: {
    DeleteSmallConfirm,
    CreateContactPerson,
  },
  mounted() {
    if (this.person > 0) {
      this.localContactPersons = [
        this.getPersonById(this.customer, this.person),
      ];
      this.emitContactPersons();
    }
  },
};
</script>
